export enum FilterType {
	DIMENSION_FILTER = 'dimension-filter',
	SHIPMENT_DIMENSION_FILTER = 'shipment-dimension-filter',
	SHIPMENT_MULTI_VALUE_TEXT_FILTER = 'shipment-multi-value-text-filter',
	SHIPMENT_MULTI_VALUE_NUMBER_FILTER = 'shipment-multi-value-number-filter',
	SHIPMENT_MULTI_VALUE_DATE_FILTER = 'shipment-multi-value-date-filter',
	ORDER_NUMBER_FILTER = 'order-number-filter',
	DOCUMENT_ORDER_NUMBER_FILTER = 'document-order-number-filter',
	NUMBER_FILTER = 'number-filter',
	EXACT_NUMBER_FILTER = 'exact-number-filter',
	DATE_FILTER = 'date-filter',
	DOCUMENT_DATE_FILTER = 'document-date-filter',
	DATE_RANGE_FILTER = 'date-range-filter',
	TEXT_FILTER = 'text-filter',
	DOCUMENT_TEXT_FILTER = 'document-text-filter',
	DROPDOWN_FILTER = 'drop-down-filter',
	SHIPMENT_MULTI_VALUE_DROPDOWN_FILTER = 'shipment-multi-value-drop-down-filter',
	SUGGESTIVE_LIST_FILTER = 'suggestive-list-filter',
	DOCUMENT_MILL_DROPDOWN_FILTER = 'document-mill-drop-down-filter',
	DOCUMENT_DATE_RANGE_FILTER = 'document-date-range-filter',
	PRODUCED_DIMENSION_FILTER = 'produced-dimension-filter'
}

export interface DimensionFilter {
	customFilterName: FilterType.DIMENSION_FILTER;
	thickness: string;
	width: string;
	length: string;
}
export interface ProducedDimensionFilter {
	customFilterName: FilterType.PRODUCED_DIMENSION_FILTER;
	producedThickness: string;
	producedWidth: string;
	producedLength: string;
}
export interface ShipmentDimensionFilter {
	customFilterName: FilterType.SHIPMENT_DIMENSION_FILTER;
	thicknessDimensionConcat: string;
	widthDimensionConcat: string;
	lengthDimensionConcat: string;
}

export interface TextFilter {
	customFilterName:
		| FilterType.TEXT_FILTER
		| FilterType.DOCUMENT_TEXT_FILTER
		| FilterType.SHIPMENT_MULTI_VALUE_TEXT_FILTER;
	searchText?: string;
	searchTexts?: string[];
}

export interface DropdownFilter {
	customFilterName: FilterType.DROPDOWN_FILTER
		| FilterType.SHIPMENT_MULTI_VALUE_DROPDOWN_FILTER
		| FilterType.DOCUMENT_MILL_DROPDOWN_FILTER
		| FilterType.SUGGESTIVE_LIST_FILTER;
	text: string;
}

export interface NumberRange {
	lessThan?: number;
	moreThan?: number;
}

export interface NumberFilter extends NumberRange {
	customFilterName: FilterType.NUMBER_FILTER | FilterType.SHIPMENT_MULTI_VALUE_NUMBER_FILTER;
	ranges?: NumberRange[];
}

export interface ExactNumberFilter {
	customFilterName: FilterType.EXACT_NUMBER_FILTER;
	value?: number;
}

export interface OrderNumber {
	reference?: string;
	item?: string;
}

export interface OrderNumberFilter extends OrderNumber {
	customFilterName: FilterType.ORDER_NUMBER_FILTER | FilterType.DOCUMENT_ORDER_NUMBER_FILTER;
	list?: OrderNumber[];
}

export interface DateRange {
	from?: Date;
	to?: Date;
}

export interface DateRangeFilter extends DateRange {
	customFilterName: FilterType.DATE_RANGE_FILTER | FilterType.DOCUMENT_DATE_RANGE_FILTER;
	format?: 'date' | 'week';
	ranges?: DateRange[];
}

export interface DateFilter {
	customFilterName:
		| FilterType.DATE_FILTER
		| FilterType.DOCUMENT_DATE_FILTER
		| FilterType.SHIPMENT_MULTI_VALUE_DATE_FILTER;
	date: Date | string;
}

export type FilterModel = TextFilter
	| DimensionFilter
	| NumberFilter
	| OrderNumberFilter
	| DateRangeFilter
	| DateFilter
	| DropdownFilter
	| ShipmentDimensionFilter | ExactNumberFilter | ProducedDimensionFilter;
